import React, { useState } from 'react';

const Dashboard = () => {
  const [section, setSection] = useState('employees');

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">📊 Πίνακας Διαχείρισης</h2>

      <div className="flex gap-4 mb-4">
        <button onClick={() => setSection('employees')} className={section === 'employees' ? 'bg-indigo-600 text-white px-4 py-2 rounded' : 'bg-gray-200 px-4 py-2 rounded'}>
          👩‍💼 Υπάλληλοι
        </button>
        <button onClick={() => setSection('customers')} className={section === 'customers' ? 'bg-indigo-600 text-white px-4 py-2 rounded' : 'bg-gray-200 px-4 py-2 rounded'}>
          🧑‍💇 Πελάτες
        </button>
        <button onClick={() => setSection('services')} className={section === 'services' ? 'bg-indigo-600 text-white px-4 py-2 rounded' : 'bg-gray-200 px-4 py-2 rounded'}>
          💈 Υπηρεσίες
        </button>
      </div>

      <div className="bg-white border rounded p-4 shadow">
        {section === 'employees' && <p>📌 Εδώ θα μπεί η φόρμα υπαλλήλου</p>}
        {section === 'customers' && <p>📌 Εδώ θα μπεί η φόρμα πελάτη</p>}
        {section === 'services' && <p>📌 Εδώ θα μπεί η φόρμα υπηρεσίας</p>}
      </div>
    </div>
  );
};

export default Dashboard;
